import callAPI from '../ApiConfig'
import $ from "jquery";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const portTypes = async (props) => {

    return await callAPI({
        route: "port_types/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }

    })

}
const addPortType = async (props) => {


    return await callAPI({
        route: "port_types/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })

}
const editPortType = async (props) => {

    return await callAPI({
        route: "port_types/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}
const deletePortType = async (props) => {


    return await callAPI({
        route: "port_types/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        headers: {

        }
    })
}

const getPortTypeList = async (props) => {

    return await callAPI({
        route: "port_types/",
        method: "get",
        signal: props?.signal,
        params: {
            ...props?.params,
            show_list: 1
        },
        headers: {

        }

    })

}

const portTypeAPI = {
    portTypes: portTypes,
    addPortType: addPortType,
    editPortType: editPortType,
    deletePortType: deletePortType,
    getPortTypeList: getPortTypeList
}
export default portTypeAPI